import React, { useEffect, useState } from 'react';
import { Menu, X, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { useSite } from '../context/SiteContext';

const links = [];

const Navbar = () => {
  const { nav, brand } = useSite();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 btn-transition ${
        scrolled ? 'backdrop-blur-md bg-[#06080d]/85 border-b border-white/5' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-24 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group" aria-label={brand.name}>
          <span className="logo-chip rounded-xl border border-white/10 overflow-hidden">
            <img src={brand.logoUrl} alt={brand.name} className="h-20 w-auto block" />
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {(nav?.links || links).map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-slate-300 hover:text-white btn-transition relative"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex">
          <Button
            asChild
            className="bg-brand-green hover:bg-brand-green-light text-black font-medium btn-transition"
          >
            <a href={nav.cta.href} className="flex items-center gap-2">
              {nav.cta.label} <ArrowRight className="h-4 w-4" />
            </a>
          </Button>
        </div>

        <button
          className="lg:hidden p-2 text-white btn-transition hover:text-brand-green-light"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/5 bg-[#06080d]/95 backdrop-blur-md">
          <div className="px-6 py-4 flex flex-col gap-3">
            {(nav?.links || links).map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="text-slate-200 py-2 btn-transition hover:text-brand-green-light"
                onClick={() => setOpen(false)}
              >
                {l.label}
              </a>
            ))}
            <Button
              asChild
              className="bg-brand-green hover:bg-brand-green-light text-black font-medium w-full btn-transition"
              onClick={() => setOpen(false)}
            >
              <a href={nav.cta.href}>{nav.cta.label}</a>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
